// extracted by mini-css-extract-plugin
module.exports = {"betReceipt":"_3177b4c","content":"_7a66668","main":"_85596fc","title":"_1203fa8"};